import React from "react";

const IconCheckO = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 28.01 28.004"
    >
      <g
        dataname="Group 1745"
        transform="translate(-291.97 -382.496)"
      >
        <path
          dataname="Path 9210"
          d="M302.27,394.17l3.9,4.19,9.444-9.182a.961.961,0,0,0,.071-1.321,13,13,0,1,0,3.3,8.643"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default IconCheckO;
